import React from 'react';
import BubbleNavigation from '../BubbleUI/BubbleNavigation';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import { resolveLibrariesPath, resolveAssetsPath } from '@go-client/routes';

export default function LibrariesNavigation(props: { active: 'libraries' | 'assets' }) {
  const { activeProperty: property } = useActiveProperty();

  return (
    <BubbleNavigation
      items={[
        {
          name: 'Libraries',
          to: resolveLibrariesPath(property._id, 'events'),
          active: props.active === 'libraries',
          variant: 'titanium',
        },
        {
          name: 'Assets',
          to: resolveAssetsPath(property._id, 'images'),
          active: props.active === 'assets',
          variant: 'titanium',
        },
      ]}
    />
  );
}
